var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ratio ratio-16x9"},[_c('video',{attrs:{"autoplay":"","controls":"","disablePictureInPicture":"","controlsList":"nodownload noremoteplayback noplaybackrate"}},[_c('source',{attrs:{"src":require('@/assets/' + _vm.path),"type":_vm.type}}),_vm._v(" Your browser does not support the video tag. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }